import React from 'react'
import { Radio, Divider, Icon  } from 'antd';


export const RadioGroupComponent = ({ options = [], onChangeRadio = () =>{} }) => {
    const [value, setValue] = React.useState(1);

    const onChange = e => {

        onChangeRadio(e.target.value);
        
        setValue(e.target.value);
    };

    const radioStyle = {
        display: 'block',
        height: '40px',
        lineHeight: '40px',

    };


    return (
        <div>
            <Radio.Group onChange={onChange} value={value}>
                {
                    options.map( (item, key) => (
                        <div key={ key }>
                            <Radio style={radioStyle} value={ item.value }>{ item.title }</Radio>
                            {/* <Divider style={{ margin: '8px 0'}} /> */}
                        </div>
                    ))
                }
            </Radio.Group>
        </div>
    )
}
